import React from 'react';
export default React.createContext(null);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-transition-group/esm/TransitionGroupContext.js
// module id = 137
// module chunks = 0